export default "__VITE_ASSET__BUGtMcw8__"